module.exports = __webpack_public_path__ + "img/levelup-background-element.82aee449.svg";